






























import { 
  ref,
  useFetch,
  defineComponent
} from '@nuxtjs/composition-api';
import { SfHeading } from '@storefront-ui/vue';
import type { PropType } from '@nuxtjs/composition-api';
import type { NuxtError } from '@nuxt/types';
import { useContent } from '~/composables';
import { CmsBlock } from '~/modules/GraphQL/types';
import PageBuilder from '~/components/PageBuilder/PageBuilder.vue';

export default defineComponent({
  components: {
    SfHeading,
    PageBuilder,
  },
  props: {
    error: {
      type: Object as PropType<NuxtError>,
      required: true,
    },
  },
  setup() {
    const {
      loadBlocks,
    } = useContent();
    const blocks = ref<CmsBlock[]>([]);

    useFetch(async () => {
      const blockIds = ['404_not_found'];
      blocks.value = await loadBlocks({
        identifiers: blockIds,
        customQuery: {
          cmsBlocks: 'cmsBlock'
        }
      });
    });

    return {
      blocks
    };
  },
});
